"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLabel = getLabel;
const react_1 = __importDefault(require("react"));
const ramda_1 = require("ramda");
const wl_ui_kit_1 = require("@invent/wl-ui-kit");
const styled_components_1 = __importDefault(require("styled-components"));
const Label = styled_components_1.default.span ``;
function getLabel(field) {
    const required = field.schema.required || field.required;
    const asterisk = required ? react_1.default.createElement(MarkIcon, null) : null;
    return !(0, ramda_1.isEmpty)(field.label) ? (react_1.default.createElement(Label, null,
        field.label,
        asterisk)) : null;
}
const Mark = styled_components_1.default.svg `
  width: ${(0, wl_ui_kit_1.getSizeBy)(4)};
  margin-left: 2px;
  color: ${(0, wl_ui_kit_1.getColorShade)('danger', 'mediumEmphasis')};
  vertical-align: top;
`;
const MarkIcon = () => (react_1.default.createElement(Mark, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 20" },
    react_1.default.createElement("path", { d: "M7.02413 14L7.43164 11.008L5.02949 12.8753L4 11.0716L6.80965 9.96817L4.02145 8.90716L4.9866 7.18833L7.45308 9.03448L7.02413 6H9.01877L8.58981 9.03448L11.0349 7.18833L11.9786 8.88594L9.19035 9.98939L12 11.0928L10.992 12.8541L8.58981 11.008L8.99732 14H7.02413Z", fill: "currentColor" })));
//# sourceMappingURL=helpers.js.map